import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { LocationStrategy } from '@angular/common';

@Component({
  standalone: false,
  selector: 'app-loyalty-approve-tile',
  templateUrl: './loyalty-approve-tile.component.html'
})
export class LoyaltyApproveTileComponent implements OnInit {
  @Output() approveTrigger: EventEmitter<void> = new EventEmitter<void>();

  public acceptTerms: UntypedFormControl;
  public termsLink: string;
  loyaltyApproveTileDescriptionString = $localize`:@@loyalty-approve-tile.loyaltyApproveTileDescription:With <b>Amadeus+Me</b>, your agents get rewards for their bookings.`;
  moreDetailsString = $localize`:@@loyalty-approve-tile.moreDetails:More details`;
  loyaltyApproveTileAcceptTermsOfUse = $localize`:@@loyalty-approve-tile.loyaltyApproveTileAcceptTermsOfUse:I grant permission to my travel agents to access Amadeus+Me and agree to the `;

  constructor(private readonly fb: FormBuilder, private readonly location: LocationStrategy) {
    this.acceptTerms = this.fb.control(false, Validators.requiredTrue);
  }
  ngOnInit(): void {
    this.termsLink = this.location.prepareExternalUrl('/content/registration-amadeus-plus-me-agreement');
  }
  handleApprove() {
    if (this.acceptTerms.invalid) {
      return;
    }

    this.approveTrigger.emit();
  }
}
